<script lang="ts">
  import { getContext } from 'svelte'
  import { ChevronDown, ChevronRight } from '@lucide/svelte'
  import IconButton from '../icon-button/IconButton.svelte'
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement> & {
    containerClassName?: string
    empty?: boolean
  }

  let {
    children,
    containerClassName,
    class: className,
    empty,
    ...rest
  }: Props = $props()

  const { open, disabled } = getContext('pane') as PaneContext

  function toggleOpen() {
    open.set(!$open)
  }
</script>

<div class={['container', containerClassName]}>
  {#if !$disabled}
    <IconButton disabled={empty} class="toggle" onclick={toggleOpen}>
      {#if $open && !empty}
        <ChevronDown />
      {:else}
        <ChevronRight />
      {/if}
    </IconButton>
  {/if}
  <div class={['content', className]} {...rest}>
    {@render children?.()}
  </div>
</div>

<style lang="scss">
  .container {
    display: flex;
    align-items: center;
    padding: 0 0.5rem;

    :global(.toggle) {
      margin-right: 0.125rem;
    }

    .content {
      width: 100%;
      min-height: 3rem;
      display: flex;
      align-items: center;

      :global(p) {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>
